import React from "react";

const TopHeader = ({ title, icon, date, description, rightActions, onRefresh, isRefreshing }) => (
   <header className="top-header">
      <div
         style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
         }}
      >
         <div>
            <h1 className="header-title">
               {icon && <i className={icon}></i>}
               {title}
            </h1>
            {description && <p className="dashboard-desc mb-0 mt-1">{description}</p>}
            {date && <span className="header-date">{date}</span>}
         </div>
         <div
            className="header-actions"
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
         >
            {rightActions}
            {onRefresh && (
               <button className="btn btn-light btn-sm" onClick={onRefresh} disabled={isRefreshing}>
                  <i className={`bi bi-arrow-clockwise ${isRefreshing ? "spin" : ""}`}></i>
                  {isRefreshing ? "Refreshing..." : "Refresh"}
               </button>
            )}
         </div>
      </div>
   </header>
);

export default TopHeader;
